import React from 'react';
import { ErrorBoundary } from '@components/ErrorBoundary';
import AvDebugProvider from './context/AvDebugProvider';
import AvQueryProvider from './context/AvQueryProvider';
import { NetworkStatusProvider } from './context/NetworkStatusContext';
import AvNotificationProvider from './context/NotificationProvider';
import './index.css';
import { AppThemeProvider } from './context/AppThemeProvider';
import { RouterContextProvider } from './RouterContext';

export const RouterOuterWrapper = ({ children }: React.PropsWithChildren) => (
  <AppThemeProvider>
    <ErrorBoundary>
      <AvDebugProvider>
        <AvNotificationProvider>
          <NetworkStatusProvider>
            <AvQueryProvider>
              <RouterContextProvider>{children}</RouterContextProvider>
            </AvQueryProvider>
          </NetworkStatusProvider>
        </AvNotificationProvider>
      </AvDebugProvider>
    </ErrorBoundary>
  </AppThemeProvider>
);
